import React from 'react';
import { Plus } from 'lucide-react';

interface ImageUploadBoxProps {
  readonly inputKey: string;
  readonly fileInputRef: Record<string, HTMLInputElement | null>;
  readonly onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly width?: string;
  readonly height?: string;
  readonly iconSize?: number;
  readonly fontSize?: string;
  readonly label?: string;
  readonly title?: string;
}

export const ImageUploadBox: React.FC<ImageUploadBoxProps> = ({
  inputKey,
  fileInputRef,
  onFileUpload,
  width = '150px',
  height = '150px',
  iconSize = 32,
  fontSize = '0.75rem',
  label = 'Upload',
  title = 'Upload custom image',
}) => {
  const isResponsive = width === '100%';

  return (
    <>
      <div
        onClick={() => fileInputRef[inputKey]?.click()}
        style={{
          width,
          height: isResponsive ? undefined : height,
          paddingBottom: isResponsive ? '100%' : undefined,
          position: isResponsive ? 'relative' : undefined,
          border: '3px dashed #0d6efd',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8f9fa',
          cursor: 'pointer',
          transition: 'all 0.2s',
          gap: '8px',
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.background = '#e7f3ff';
          e.currentTarget.style.borderColor = '#0d6efd';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.background = '#f8f9fa';
          e.currentTarget.style.borderColor = '#0d6efd';
        }}
        title={title}
      >
        <div
          style={
            isResponsive
              ? {
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '8px',
                }
              : undefined
          }
        >
          <Plus size={iconSize} color="#0d6efd" />
          <small style={{ color: '#0d6efd', fontSize }}>{label}</small>
        </div>
      </div>
      <input
        ref={(el) => (fileInputRef[inputKey] = el)}
        type="file"
        accept="image/jpeg,image/jpg,image/png,image/webp"
        style={{ display: 'none' }}
        onChange={onFileUpload}
        title="Upload image (will be converted to WebP)"
      />
    </>
  );
};

export const getFileName = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    return pathname.substring(pathname.lastIndexOf('/') + 1);
  } catch {
    return url.substring(url.lastIndexOf('/') + 1);
  }
};
